import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useDashboardTheme, ACCENT_COLOR, cardSx, panelHeaderSx, accentBarSx, fmt, fmtBtc } from '../utils';

function LastWinsTicker({ lastWins }) {
  const t = useDashboardTheme();
  if (!lastWins || lastWins.length === 0) return null;

  const fmtTs = (ts) => {
    if (!ts) return '';
    const d = new Date(ts);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  return (
    <Card sx={{ ...cardSx, mb: 3 }}>
      <MDBox sx={accentBarSx} />
      <MDBox sx={panelHeaderSx(t)}>
        <MDTypography variant='button' fontWeight='bold' sx={{ fontSize: '0.82rem', color: t.primaryText }}>
          Last Wins
        </MDTypography>
        <MDTypography variant='caption' sx={{ fontSize: '0.68rem', color: t.secondaryText }}>
          {lastWins.length} recent
        </MDTypography>
      </MDBox>
      <MDBox px={{ xs: 1.5, sm: 2.5 }} py={1.5} display='flex' flexWrap='wrap' gap={1}>
        {lastWins.map((w, i) => (
          <MDBox
            key={i}
            display='inline-flex'
            alignItems='center'
            gap={0.75}
            sx={{
              px: 1.5,
              py: 0.65,
              borderRadius: '10px',
              border: `1px solid ${t.divider}`,
              background: t.rowAlt,
              '@media (hover: hover)': { '&:hover': { background: t.rowHover } },
              transition: 'background 0.15s'
            }}
          >
            <MDBox
              sx={{
                width: 5,
                height: 5,
                borderRadius: '50%',
                background: ACCENT_COLOR,
                flexShrink: 0,
                opacity: i === 0 ? 1 : 0.3
              }}
            />
            <MDTypography
              variant='caption'
              fontWeight='bold'
              sx={{ fontSize: '0.72rem', color: t.primaryText, whiteSpace: 'nowrap' }}
            >
              {w.name}
            </MDTypography>
            <MDTypography
              variant='caption'
              sx={{ fontSize: '0.66rem', color: t.secondaryText, fontFamily: 'monospace', whiteSpace: 'nowrap' }}
            >
              {fmtBtc(w.amountBtc)}
            </MDTypography>
            <MDTypography
              variant='caption'
              sx={{ fontSize: '0.64rem', color: t.secondaryText, opacity: 0.7, whiteSpace: 'nowrap' }}
            >
              ${fmt(w.amountUsd)}
            </MDTypography>
            <MDTypography
              variant='caption'
              sx={{
                fontSize: '0.6rem',
                color: t.secondaryText,
                textTransform: 'uppercase',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                opacity: 0.6
              }}
            >
              {w.currency}
            </MDTypography>
            <MDTypography
              variant='caption'
              sx={{ fontSize: '0.6rem', color: t.secondaryText, fontFamily: 'monospace', opacity: 0.5, whiteSpace: 'nowrap' }}
            >
              {fmtTs(w.timestamp)}
            </MDTypography>
          </MDBox>
        ))}
      </MDBox>
    </Card>
  );
}

export default LastWinsTicker;
